import React from 'react'
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from "react-router-dom"
import '../components/css/ProjectGallery.css'

import ImageData from "./MasterplanImageData";
import { Helmet } from 'react-helmet';
import MasterplanFilter from './masterplan_filter/MasterplanFilter';

function Rumah() {

    return (
        <div className="gallery-house fade">

            <div className="gallery-house-hero-image">
                <div className="gallery-house-hero-text">
                    <h1 className='gallery-house-h1'>PROYEK MASTERPLAN</h1>
                </div>
            </div>

            {/** Include filter project gallery */}
            <MasterplanFilter/>

            {/**
            <div className="row-house">

                <div className="column-house">
                    <div className="project-header" id="id-project-rumah">
                        <div className="project-container">
                            {ImageData.map((content) => (
                                <img src={content.MASTERPLAN_PROJECT_NAME} alt="Thumb" className="image" />
                            ))}

                            <div className="project-overlay">
                                <div className='content-title'>
                                    <p>Masterplan</p>
                                </div>

                                <div className='content-year'>
                                    <p>2022</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            */}

        </div>
    )
}

export default Rumah